export const simulateMouseClick = (element: HTMLElement) => {
  const events = ['mousedown', 'click', 'mouseup'];
  events.forEach((mouseEventType) =>
    element.dispatchEvent(
      new MouseEvent(mouseEventType, {
        view: window,
        bubbles: true,
        cancelable: true,
        buttons: 1,
      }),
    ),
  );
};
